import adapter from './adapter';

export default Object.assign(Object.create(adapter), {
  /**
   * Проверяет аутентификацию пользователя в системе.
   * Пользователь является аутентифицированным если:
   * - на клиенте установлена сессионная кука token и на сервере существует
   *   соответствующая ей сессия пользователя;
   * или
   * - при проверке сессия пользователя была успешно восстановлена по имеющейся
   *   куки "запомнить меня" rememberToken.
   *
   * Метод возвращает объект Promise, в обработчик которого передается:
   * - объект данных пользователя, если проверка прошла успешно (пользователь аутентифицирован);
   * - значение false, если пользователь не может быть аутентифицирован.
   *
   * Если не удалось выполнить проверку, то в обработчик ошибки передается объект Error.
   * При инициализации (перезагрузке?) приложения потребуется пароль иначе сессия
   * постарается восстановиться
   *
   * @returns {Promise<Object|boolean, AxiosError>}
   */
  check(mode) {
    if (mode !== 'init') {
      return this.getData(
        'auth.check',
        { params: { restore: 1 } },
        null,
        false
      );
    } else {
      return this.getData('auth.check', { params: {} }, null, false);
    }
  },

  /**
   * Аутентифицирует (создает сессию) пользователя в системе.
   *
   * @param {string} login
   * @param {string} password
   * @param {boolean} [remember]
   * @returns {Promise<Object, AxiosError>}
   */
  login(login, password, remember = false) {
    let data = { login, password, remember: remember ? 1 : 0 };

    return this.post('auth.login', data, false).then(result => result.data);
  },

  /**
   * Удаляет сессию пользователя в системе:
   * - удаляет сессионные данные на сервере;
   * - удаляет куки аутентификации token и rememberToken.
   *
   * @returns {Promise<void, AxiosError>}
   */
  logout() {
    return this.post('auth.logout');
  }
});
